angular.module('tgaAdmin').controller('PlayerController', [
  '$scope',
  '$uibModalInstance',
  '$filter',
  'playerService',
  'extra',
  '$log',
  function ($scope, $uibModalInstance, $filter, playerService, extra, $log) {
    $scope.data = angular.copy(extra.player);

    $scope.countupOptions = {
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimal: ':',
    };

    $scope.viewmodel = {
      sessions: [],
      sessions_score: {},
      questions: [],
      question_groups: [],
      game: extra.game,
      required_fields: extra.required_fields,
    };

    $scope.initialize = function () {
      $scope.loading = true;

      if ($scope.viewmodel.game.game_type === 'category_quest') {
        playerService
          .getTurnLogs(
            extra.player.id,
            extra.game_id,
            extra.startDate.toISOString(true),
            extra.endDate.toISOString(true),
          )
          .then((response) => {
            for (const log of response.data) {
              $scope.viewmodel.sessions_score[log.session_id] = {
                correct_answer_points: log.correct_answer_points,
                item_bonus_points: log.item_bonus_points,
                speed_bonus_points: log.speed_bonus_points,
                time_bonus_points: log.time_bonus_points,
              };
            }
          });

        $scope.viewmodel.total_game_questions = $scope.viewmodel.game.question_groups.reduce(
          (total, question_groups) => total + question_groups.questions.length,
          0,
        );
      }

      playerService
        .getPlayer(extra.player.id, extra.game_id, extra.startDate.toISOString(true), extra.endDate.toISOString(true))
        .then((data) => {
          $log.log('player', data);
          const avg_time = $filter('formatDuration')(data.average_time).split(':');
          $scope.viewmodel.avgTime = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
          $scope.viewmodel.high_score = data.high_score;
          $scope.viewmodel.total_sessions = data.total_sessions;
          $scope.viewmodel.sessions = data.sessions;
          $scope.viewmodel.questions = data.questions;
          $scope.viewmodel.avg_turns = data.average_turns;
          $scope.loading = false;
        });
    };

    $scope.getters = {
      sortPlayerQuestionsCorrect: function sortPlayerQuestionsCorrect(row) {
        return row.total_correct / (row.total_answered || 1);
      },
      sortPlayerQuestionsIncorrect: function sortPlayerQuestionsIncorrect(row) {
        return row.total_incorrect / (row.total_answered || 1);
      },
      sortQuestionText: function sortQuestionText(row) {
        return row.text;
      },
      sortQuestionCorrect: function sortQuestionCorrect(row) {
        return row.total_correct / (row.total_answered || 1);
      },
      sortQuestionIncorrect: function sortQuestionIncorrect(row) {
        return row.total_incorrect / (row.total_answered || 1);
      },
      sortQuestionFirst: function sortQuestionFirst(row) {
        return row.total_correct_first / (row.total_first || 1);
      },
      sortQuestionSecond: function sortQuestionSecond(row) {
        return row.total_correct_second / (row.total_second || 1);
      },
      sortQuestionThird: function sortQuestionThird(row) {
        return row.total_correct_third / (row.total_third || 1);
      },
    };

    $scope.actions = {
      ok(data) {
        $uibModalInstance.close(data);
      },
      cancel(data) {
        $uibModalInstance.dismiss(data);
      },
    };

    $scope.initialize();
  },
]);
